import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import {
  Save, Plus, Trash2, Edit, X, Eye, EyeOff, Loader2, Image as ImageIcon,
  Star, Mail, User, Phone, Lock, Shield, FileText, ChevronDown, ChevronUp
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TestimonialModal = ({ testimonial, onSave, onClose, saving }) => {
  const [formData, setFormData] = useState({
    client_name: testimonial?.client_name || '',
    client_location: testimonial?.client_location || '',
    service_type: testimonial?.service_type || 'mortgage',
    rating: testimonial?.rating || 5,
    testimonial_text: testimonial?.testimonial_text || '',
    published: testimonial?.published ?? true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="flex flex-row items-center justify-between border-b">
          <CardTitle>{testimonial ? 'Edit Testimonial' : 'New Testimonial'}</CardTitle>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="h-5 w-5" />
          </Button>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Client Name</label>
                <input
                  type="text"
                  value={formData.client_name}
                  onChange={(e) => setFormData({ ...formData, client_name: e.target.value })}
                  required
                  placeholder="John & Jane D."
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0077B6]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Location</label>
                <input
                  type="text"
                  value={formData.client_location}
                  onChange={(e) => setFormData({ ...formData, client_location: e.target.value })}
                  required
                  placeholder="Winnipeg, MB"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0077B6]"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Service Type</label>
                <select
                  value={formData.service_type}
                  onChange={(e) => setFormData({ ...formData, service_type: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0077B6]"
                >
                  <option value="mortgage">Mortgage Services</option>
                  <option value="insurance">Insurance</option>
                  <option value="investment">Investments</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Rating</label>
                <div className="flex items-center gap-1 pt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => setFormData({ ...formData, rating: star })}
                      className="focus:outline-none"
                    >
                      <Star
                        className={`h-6 w-6 ${
                          star <= formData.rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-gray-300'
                        }`}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Testimonial</label>
              <textarea
                value={formData.testimonial_text}
                onChange={(e) => setFormData({ ...formData, testimonial_text: e.target.value })}
                required
                rows={4}
                placeholder="Write the client's testimonial..."
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0077B6]"
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="testimonial-published"
                checked={formData.published}
                onChange={(e) => setFormData({ ...formData, published: e.target.checked })}
                className="h-4 w-4"
              />
              <label htmlFor="testimonial-published" className="text-sm font-medium">Published</label>
            </div>
            <div className="flex gap-3 pt-4">
              <Button type="button" variant="outline" onClick={onClose} className="flex-1">
                Cancel
              </Button>
              <Button type="submit" disabled={saving} className="flex-1 bg-[#0077B6]">
                {saving ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <Save className="h-4 w-4 mr-2" />
                    Save
                  </>
                )}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

// Agent Modal Component
